export default __webpack_public_path__ + "static/media/Book-2.8955f327.jpg";